/**
 * Stack Component
 *
 * A container that arranges children vertically with spacing.
 * Component follows Smoothie UI architecture.
 *
 * @module @smoothie-framework/ui/components
 */
import { BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS } from '@smoothie-framework/ui-styles/styling/contract';
import { buildFlexContainerNode, } from '../../authoring/flex-layout';
export function Stack(props) {
    const { id, as, asChild, direction = defaultStackProps.direction, gap = defaultStackProps.gap, align = defaultStackProps.align, justify = defaultStackProps.justify, wrap = defaultStackProps.wrap, style, role, ariaLabel, ariaLabelledBy, 'aria-labelledby': ariaLabelledByAttribute, ariaDescribedBy, className, children, 'data-ui': dataUi, ...utilityPropsInput } = props;
    return buildFlexContainerNode({
        componentType: 'Stack',
        baseClass: 'smth-stack',
        defaultDataUi: 'Stack',
        defaultGap: defaultStackProps.gap,
        defaultAlign: defaultStackProps.align,
        defaultJustify: defaultStackProps.justify,
        defaultWrap: defaultStackProps.wrap,
        defaultDirection: defaultStackProps.direction,
        gap,
        align,
        justify,
        wrap,
        direction,
        emitDirectionProp: true,
        id,
        as,
        asChild,
        style,
        role,
        ariaLabel,
        ariaLabelledBy: ariaLabelledBy !== undefined ? ariaLabelledBy : ariaLabelledByAttribute,
        ariaDescribedBy,
        className,
        children,
        dataUi,
        utilityPropsInput,
    });
}
const stackDefaultUtilityProps = BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS.Stack;
export const defaultStackProps = Object.freeze({
    direction: stackDefaultUtilityProps.direction,
    gap: stackDefaultUtilityProps.gap,
    align: stackDefaultUtilityProps.align,
    justify: stackDefaultUtilityProps.justify,
    wrap: stackDefaultUtilityProps.wrap,
});
//# sourceMappingURL=Stack.js.map